import { OutlineElement } from '../../../base/outline-element/outline-element';
import { CSSResultGroup, html, TemplateResult, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import componentStyles from './ghs-about-me-text.css.lit';
import { SlotController } from '../../../controllers/slot-controller';

/**
 *
 * @elementsList - this is a list of all elements and attributes, surveyed from Figma.
 * -title - always present, string.
 * -text - always present, string.
 *
 * @orderedElementsList - this is a list of all elements, with their order pieced together, from Figma.
 *    title
 *      heading
 *    text
 *      text
 */

/**
 * The GHS About Me Text component
 * @element ghs-about-me-text
 * @slot - about-me-text-title, title of the section.
 * @slot - about-me-text, body of the section.
 */
@customElement('ghs-about-me-text')
export class GhsAboutMeText extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  slots = new SlotController(this, true);

  @state() hasTitleSlot: boolean;
  @state() hasTextSlot: boolean;

  firstUpdated(): void {
    super.firstUpdated();
    this.hasTitleSlot = this.slots.test('about-me-text-title');
    this.hasTextSlot = this.slots.test('about-me-text');
  }
  render(): TemplateResult {
    return html`
      <div class="about-me-text-wrapper">
        ${this.hasTitleSlot
          ? html`
              <ghs-heading
                level="h3"
                level-size="3xl"
                level-style="semibold"
                class="about-me-heading"
                site=${this.site}
              >
                <slot name="about-me-text-title"></slot>
              </ghs-heading>
            `
          : nothing}
        ${this.hasTextSlot
          ? html`
              <div class="about-me-text">
                <slot name="about-me-text"></slot>
              </div>
            `
          : nothing}
      </div>
    `;
  }
}
